import React, { Suspense, useEffect } from "react";
import RouterApp from "./router/AppRouter";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { getEmail } from "./services/storage";
import { BRAND } from "./services/brand";

const appVersion = require("../package.json").version;
const bugsnagEnabled = process.env.REACT_APP_ENV_NAME === "prod";

let ErrorBoundary: React.ComponentType<{ children?: React.ReactNode }> = ({ children }) => <>{children}</>;

if (bugsnagEnabled) {
  Bugsnag.start({
    apiKey: "add6af016d7a651fd74ea1f4ec9cb56a",
    plugins: [new BugsnagPluginReact()],
    enabledBreadcrumbTypes: [
      "error",
      "log",
      "navigation",
      "request",
      "user",
      "state",
    ],
    releaseStage: process.env.REACT_APP_ENV_NAME,
    enabledReleaseStages: ["prod"],
    appVersion,
    onError: function (event) {
      event.setUser(undefined, getEmail() || undefined, appVersion);
    },
  });
  ErrorBoundary = Bugsnag.getPlugin("react")!.createErrorBoundary(React);
}

function App() {
  useEffect(() => {
    console.log(`<< RUNNING ${BRAND.compactName} with ${process.env.REACT_APP_ENV_NAME} env >>`)
  }, [])

  return (
    <Suspense>
      <ErrorBoundary>
        <title>{`${BRAND.name} | Admin`}</title>
        <RouterApp />
      </ErrorBoundary>
    </Suspense>
  );
}

export default App;
